import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-[#C24D2C]">Gallery</p>
        <h1 className="mt-4 font-serif-display text-5xl lg:text-6xl text-[#1A2456] font-bold">Moments in the field.</h1>

        {loading ? (
          <p className="mt-14 text-[#8A817C]">Loading…</p>
        ) : items.length === 0 ? (
          <p className="mt-14 text-[#8A817C] italic">Photos will appear here.</p>
        ) : (
          <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((g, i) => (
              <button
                key={g.id}
                data-testid={`gallery-item-${g.id}`}
                onClick={() => setPreview(g)}
                className={`group relative overflow-hidden ${i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-square"}`}
              >
                <img
                  src={g.image_url}
                  alt={g.caption || "Gallery"}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {g.caption && (
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A2456]/85 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                    <p className="text-white text-sm font-serif-display">{g.caption}</p>
                  </div>
                )}
              </button>
            ))}
          </div>
        )}
      </section>

      {preview && (
        <div
          data-testid="gallery-preview"
          onClick={() => setPreview(null)}
          className="fixed inset-0 bg-[#1A2456]/95 z-[60] flex items-center justify-center p-6 cursor-zoom-out"
        >
          <img src={preview.image_url} alt={preview.caption} className="max-h-[85vh] max-w-full object-contain" />
        </div>
      )}
    </div>
  );
}
